<div class="call-connect">
    <a data-toggle="modal" data-target="#callBackModal">
        <img src="assets/images/contact-call-icon.png" class="img-fluid" alt="contact us">
        <span>Request a Call Back</span>
    </a>
    <nav class="call-menu">
        <ul>
            <li data-toggle="modal" data-target="#callBackModal">
                <i class="fa fa-phone"></i>
                <span>A Call Back</span>
            </li>
            <li data-toggle="modal" data-target="#contactModal">
                <i class="fa fa-envelope"></i>
                <span>Contact Us</span>
            </li>
        </ul>
    </nav>
</div>

<div class="modal fade" id="callBackModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="contact-dealer-form">
                <button type="button" class="closeone" data-dismiss="modal"><i class="ti-close"></i></button>
                <span class="login100-form-title">
                    <div><img src="assets/images/propira-logo.webp" class="img-fluid" alt="logo"></div>
                    Request a Call Back
                </span>

                <form class="validate-form white-layer" [ngClass]="{'white-layer':callbackLoader}" [formGroup]="callback" (ngSubmit)="callbackEnd()">
                    <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="callbackSuccessMsg">
                        <i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHtml]="callbackSuccessMsg"></span>
                    </p>
                    <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="callbackErrorMsg">
                        <i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="callbackErrorMsg"></span>
                    </p>
                    <div class="wrap-input100">
                        <input type="text" placeholder="Full Name" required class="form-control" formControlName="name" onkeypress="return /[A-Za-z ]/i.test(event.key)">
                        <span class="error-msg" *ngIf="!callback.get('name').valid && callbackSubmit">
                            <p class="error" >Enter valid name</p>
                        </span>
                    </div>
                    <div class="wrap-input100 new234" style="z-index: 1;">
                        <ngx-intl-tel-input [enableAutoCountrySelect]="true" [searchCountryFlag]="false" [selectFirstCountry]="false" [preferredCountries]="['in']" [selectedCountryISO]="CountryISO.India" [maxLength]="15" [phoneValidation]="true" name="phone" [enablePlaceholder]="false"
                            [separateDialCode]="true" formControlName="contact_no" class="w-100"></ngx-intl-tel-input>
                        <!-- <input class="input100" type="text" id="phone" ng2TelInput (countryChange)="onCountryChange($event)" [ng2TelInputOptions]="{initialCountry: 'in'}" maxlength="10" onkeypress="return /[0-9 ]/i.test(event.key)" formControlName="phone"> -->
                        <span class="error-msg" *ngIf="!callback.get('phone').valid && callbackSubmit">
                            <p class="error">Enter Valid Mobile Number</p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="text" placeholder="Type your message (Optional)" formControlName="message">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-pencil" aria-hidden="true"></i>
                        </span>
                    </div>
                    <h6>Our Promise</h6>
                    <div class="wrap-input100 promise-box">
                        <ul>
                            <li><i class="fa fa-user-secret fa-fw"></i> Assured<br>Privacy</li>
                            <li><i class="fa fa-user-o fa-fw"></i> Expert<br>Consultation</li>
                            <li><i class="fa fa-car fa-fw"></i> Free<br>Site Visit</li>
                            <li><i class="fa fa-inr fa-fw"></i> Best<br>Price</li>
                        </ul>
                    </div>
                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" type="submit">Submit
                            <div class="box" *ngIf="callbackLoader">
                                <div class="loader-13"></div>
                            </div>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="contactModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="contact-dealer-form">
                <button type="button" class="closeone" data-dismiss="modal"><i class="ti-close"></i></button>
                <span class="login100-form-title">
                    <div><img src="assets/images/propira-logo.webp" class="img-fluid" alt="logo"></div>
                    Contact Us
                </span>
                <form class="validate-form" [ngClass]="{'white-layer':contactLoader}" [formGroup]="contact" (ngSubmit)="contactEnd()">
                    <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="contactSuccessMsg">
                        <i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHtml]="contactSuccessMsg"></span>
                    </p>
                    <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="contactErrorMsg">
                        <i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="contactErrorMsg"></span>
                    </p>
                    <div class="wrap-input100">
                        <input class="input100" type="text" formControlName="name" onkeypress="return (event.charCode > 64 && 
                        event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode==32" placeholder="Contact Name" required>
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-user" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="!contact.get('name').valid">
                            <p class="error">Enter your name</p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="text" placeholder="Mobile" formControlName="phone" required>
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-mobile" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg" *ngIf="!callback.get('phone').valid">
                            <p class="error">Enter Valid Mobile Number</p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="text" placeholder="Type your message (Optional)" formControlName="message">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-pencil" aria-hidden="true"></i>
                        </span>
                        <span class="error-msg">
                            <p class="error">Enter Message</p>
                        </span>
                    </div>
                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" type="submit">Submit <div class="box" *ngIf="contactLoader">
                                <div class="loader-13"></div>
                            </div> </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<section class="button-rights">
    <button> <a class="nav-link feedback-link"  (click)="openFeedbackForm()" style="cursor:pointer;color: #fff;padding: 0px;">Feedback</a></button>
</section>

<div class="contact-dealer-form feedback-form">
    <button type="button" class="close feedback-link" (click)="openFeedbackForm()"><i class="ti-close"></i></button>
    <span class="login100-form-title">Feedback</span>
    <div class="validate-form" style="margin-bottom: -29px;">
        <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="feedbackSuccessMsg">
            <i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHtml]="feedbackSuccessMsg"></span>
        </p>
        <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="feedbackErrorMsg">
            <i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="feedbackErrorMsg"></span>
        </p>
    </div>
    <form method="post" [ngClass]="{'white-layer':feedbackLoader}" [formGroup]="feedback" (ngSubmit)="feedbackEnd()">
        <div class="validate-form feedback-first">
            <img src="assets/images/feedback.png" class="img-fluid" alt="feedback">
            <h6>Hey, how was your <b>experience <br>on Propira?</b></h6>
            <div class="wrap-input100">
                <label><input class="input100" type="radio" formControlName="rating" value="Awesome"> Awesome <i
                        class="fa fa-smile-o"></i></label>
                <label><input class="input100" type="radio" formControlName="rating" value="Good"> Good <i
                        class="fa fa-meh-o"></i></label>
                <label><input class="input100" type="radio" formControlName="rating" value="Needs Improvement"> Needs
                    Improvement <i class="fa fa-frown-o"></i></label>
            </div>
        </div>

        <div class="validate-form feedback-second" *ngIf="feedbackInfoForm">
            <img src="assets/images/feedback.png" class="img-fluid" loading="lazy" alt="feedback">
            <h6><b>Thank you</b> for your <b>feedback!</b></h6>
            <div class="wrap-input100">
                <input class="input100" type="tel" placeholder="Mobile" required formControlName="mobile" maxlength="10" onkeypress="return (!(event.charCode != 46 && event.charCode > 31  && (event.charCode < 48 || event.charCode > 57)))">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="ti-mobile" aria-hidden="true"></i>
                </span>
                <span class="error-msg" *ngIf="feedbackControl.mobile.touched && feedbackControl.mobile.errors">
                    <p class="error" *ngIf="feedbackControl.mobile.errors.required">Mobile no is required</p>
                    <p class="error" *ngIf="feedbackControl.mobile.errors.pattern">Enter Valid Mobile no.</p>
                </span>
            </div>
            <div class="wrap-input100">
                <input class="input100" type="email" placeholder="Email" required formControlName="email">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="ti-email" aria-hidden="true"></i>
                </span>
                <span class="error-msg" *ngIf="feedbackControl.email.touched && feedbackControl.email.errors">
                    <p class="error">Enter Valid Email-Id</p>
                </span>
            </div>
            <div class="wrap-input100">
                <input class="input100" type="text" placeholder="Type your message..." required formControlName="message">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="ti-pencil" aria-hidden="true"></i>
                </span>
                <span class="error-msg" *ngIf="feedbackControl.message.touched && feedbackControl.message.errors">
                    <p class="error">Enter Address</p>
                </span>
            </div>
            <div class="container-login100-form-btn">
                <button class="login100-form-btn" type="submit">Submit <div class="box" *ngIf="feedbackLoader">
                        <div class="loader-13"></div>
                    </div></button>
            </div>
        </div>
    </form>
    <div class="validate-form feedback-second" *ngIf="feedbackOtpForm">
        <form method="post" [ngClass]="{'white-layer':feedbackLoader}" [formGroup]="feedbackverify" (ngSubmit)="chkFeedbackVerify()">
            <h6><b>OTP has been sent to your mobile XXXXXX{{(feedback.value.mobile).substring(6,10)}}, please enter same
                    here to verify.</b></h6>
            <div class="wrap-input100">
                <input class="input100 change" id="otpText" formControlName="otp" type="tel" (keypress)="numberOnly($event,6)" placeholder="Enter OTP" autofocus="true" required>
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="ti-mobile" aria-hidden="true"></i>
                </span>
                <span class="error-msg" *ngIf="feedbackVerifyControl.otp.touched && feedbackVerifyControl.otp.errors">
                    <p class="error">Enter OTP</p>
                </span>
            </div>
            <div class="container-login100-form-btn">
                <button class="login100-form-btn" type="submit">Submit <div class="box" *ngIf="feedbackLoader">
                        <div class="loader-13"></div>
                    </div></button>
            </div>
        </form>
    </div>
    <div class="validate-form feedback-second" *ngIf="feedbackThankForm">
        <img src="assets/images/thanku.jpg" class="img-fluid" alt="feedback">
    </div>
</div>


<div class="container-fluid" id="footer" style="background: linear-gradient(rgba(25, 24, 29, 83%), rgba(25, 24, 29, 0.95)), url(assets/images/footer.webp); background-position: center bottom; background-size: cover;">
    <div class="footer-wrap">
        <div class="row text-center border-bottom-footer footer-top-row" style="display: none;">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <ul>
                            <li>
                                <h4 class="widgettitle">Call Now</h4>
                                <a tel="+916350500084"><span>+91-6350500084</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-md-4 col-lg-4 col-sm-4 col-12">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <ul>
                            <li class="email-icon-footer">
                                <h4 class="widgettitle">Email On</h4>
                                <a mailto="contact@propira.com"><span>contact@propira.com</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <ul>
                            <li class="download-app">
                                <h4 class="widgettitle">Propira Mobile App</h4>
                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.services.propeera"><span>Click
                                                Here to Download</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row footer-wrap footer-bt">
            <!-- Disclaimer News -->
         <div class="col-lg-12 col-md-12 col-sm-12 footr-upper-links">
            <div class="row ft-row">

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links  quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','ajmer')">New Property in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','alwar')">New Property in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','jaipur')">New Property in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','kota')">New Property in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','dausa')">New Property in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','bikaner')">New Property in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','bharatpur')">New Property in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','sikar')">New Property in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','jodhpur')">New Property in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/property-in-','udaipur')">New Property in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','ajmer')">Residential flat in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','alwar')">Residential flat in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','jaipur')">Residential flat in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','kota')">Residential flat in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','dausa')">Residential flat in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','bikaner')">Residential flat in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','bharatpur')">Residential flat in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','sikar')">Residential flat in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','jodhpur')">Residential flat in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/residential-property-for-sale-in-','udaipur')">Residential flat in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','ajmer')">New Top Project in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','alwar')">New Top Project in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','jaipur')">New Top Project in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','kota')">New Top Project in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','dausa')">New Top Project in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','bikaner')">New Top Project in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','bharatpur')">New Top Project in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','sikar')">New Top Project in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','jodhpur')">New Top Project in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/project/trending/','udaipur')">New Top Project in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','ajmer')">Commercial Property in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','alwar')">Commercial Property in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','jaipur')">Commercial Property in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','kota')">Commercial Property in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','dausa')">Commercial Property in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','bikaner')">Commercial Property in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','bharatpur')">Commercial Property in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','sikar')">Commercial Property in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','jodhpur')">Commercial Property in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/buy/commercial-property-for-sale-in-','udaipur')">Commercial Property in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','ajmer')">Properties for Rent in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','alwar')">Properties for Rent in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','jaipur')">Properties for Rent in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','kota')">Properties for Rent in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','dausa')">Properties for Rent in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','bikaner')">Properties for Rent in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','bharatpur')">Properties for Rent in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','sikar')">Properties for Rent in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','jodhpur')">Properties for Rent in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/property-for-rent-in-','udaipur')">Properties for Rent in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <div class="footer-body quick-links quick-links-1">
                    <ul>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','ajmer')">Commercial for Rent in Ajmer</a> </span>
                        </li>

                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','alwar')">Commercial for Rent in Alwar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','jaipur')">Commercial for Rent in Jaipur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','kota')">Commercial for Rent in Kota</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','dausa')">Commercial for Rent in Dausa</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','bikaner')">Commercial for Rent in Bikaner</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','bharatpur')">Commercial for Rent in Bharatpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','sikar')">Commercial for Rent in Sikar</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','jodhpur')">Commercial for Rent in Jodhpur</a> </span>
                        </li>
                        <li>
                            <span> <a href="javascript:void(0)" (click)="redirectToAnotherPage('/rent/commercial-property-for-rent-in-','udaipur')">Commercial for Rent in Udaipur</a> </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
            </div>
        </div>

        <div class="container footer-cont">
            <div class="row footer-wrap">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                    <div id="about">
                        <h4 class="widgettitle">Quick Links</h4>
                        <div class="footer-body quick-links">
                            <ul>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/about-us">About Us</a></span>
                                </li>

                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="blog">Blog</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/testimonials">Testimonials</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/term-condition">Terms & Conditions</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/privacy-policy">Privacy Policy</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                href="https://www.propira.com/sitemap.xml"
                                                target="_blank">Sitemap</a></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                    <div id="about">
                        <h4 class="widgettitle">Customer Support</h4>
                        <div class="footer-body quick-links">
                            <ul>
                                <li style="display: none;">
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/request-info">Request Info</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/feedback" class="feedback-link">Feedback</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/report-problem">Report a problem</a></span>
                                </li>
                                <li style="display: none;">
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                href="javascript:void(0);" routerLink="/help-center">Help
                                                Center</a></span>
                                </li>
                                <li style="display: none;">
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                href="javascript:void(0);" routerLink="/sales-enquiry">Sales
                                                Enquiry</a></span>
                                </li>
                                <!-- <li>
                                        <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/contact-us">Contact Us</a></span>
                                    </li> -->
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/request-callback">Request a call back</a></span>
                                </li>
                                <li>
                                    <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                routerLink="/franchisee-request">Apply Franchise</a></span>
                                </li>
                                <!-- <li>
                                        <span><i class="ti-angle-double-right" aria-hidden="true"></i><a
                                                href="mailto:support@propira.com">support@propira.com</a></span>
                                    </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <h4 class="widgettitle">Follow Us</h4>
                            <ul class="social-footer">
                                <li>
                                    <a href="https://www.facebook.com/propiraglobal" target="_blank"><i
                                                class="ti-facebook"></i>Facebook</a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/PropiraGlobal" target="_blank"><i
                                                class="ti-twitter"></i>Twitter</a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/propiraglobal" target="_blank"><i
                                                class="ti-instagram"></i>Instagram</a>
                                </li>
                                <li>
                                    <a href="https://in.pinterest.com/propiraglobal" target="_blank"><i
                                                class="ti-pinterest"></i>Pinterest</a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/propira" target="_blank"><i
                                                class="ti-linkedin"></i>Linked In</a>
                                </li>
                                <li>
                                    <a href="https://www.flickr.com/photos/propira/" target="_blank"><i
                                                class="ti-flickr"></i>Flickr</a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCdjdEMy6jVzdYabH4HY-s5g" target="_blank"><i class="ti-youtube"></i>Youtube</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 subscribe-now">
                            <h4 class="widgettitle">Subscribe Us</h4>
                            <p>Subscribe to our monthly newsletter</p>
                            <form [formGroup]="newsletter" (ngSubmit)="newsletterEnd()">

                                <span class="error-msg" style="position: relative;bottom:auto;background: #db0c0c;padding: 3px 6px;color: #fff;display: block;margin-bottom: 15px;" *ngIf="newsletterControl.email.touched && newsletterControl.email.errors">
                                        <p class="error"
                                            style="color:white;text-align: left;font-size:11px;padding:4px"><i
                                                class="ti-face-sad" aria-hidden="true"></i>&nbsp;Enter Valid Email-Id
                                        </p>
                                    </span>

                                <span class="error-msg" style="position: relative;bottom:auto;background: #db0c0c;padding: 3px 6px;color: #fff;display: block;margin-bottom: 15px;" *ngIf="newsletterErrorMsg">
                                        <p class="error"
                                            style="color:white;text-align: left;font-size:11px;padding:4px"><i
                                                class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span
                                                [innerHtml]="newsletterErrorMsg"></span></p>
                                </span>

                                <span class="error-msg" style="position: relative;bottom:auto;background: green;padding: 3px 6px;color: #fff;display: block;margin-bottom: 15px;" *ngIf="newsletterSuccessMsg">
                                        <p class="error"
                                            style="color:white;text-align: left;font-size:11px;padding:4px"><i
                                                class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span
                                                [innerHtml]="newsletterSuccessMsg"></span></p>
                                </span>
                                <div class="wrap-input100">
                                    <input class="input100" type="email" placeholder="Email-Id" required formControlName="email">
                                    <span class="focus-input100"></span>
                                    <span class="symbol-input100">
                                            <i class="ti-email" aria-hidden="true"></i>
                                        </span>
                                </div>
                                <div>
                                    <button class="login100-form-btn" type="submit">Subscribe
                                            <div class="box" *ngIf="newsletterLoader">
                                                <div class="loader-13"></div>
                                            </div>
                                        </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row footer-wrap border-top-footer mt-4 mt-sm-0">
            <!-- Disclaimer News -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 paddXZ">
                <div class="disclaimer-footer">
                    <p style="font-size: 11px;margin-bottom:7px"><strong>Disclaimer: </strong>The information contained in this website is for general information purposes and is solely intended to provide general information prevailing real estate properties and projects and to help you assess
                        whether you need more detailed information. The recommendations or information on this website is not and should not be regarded as legal or real estate advice. We do not guarantee or warrant the accuracy, completeness, or authenticity
                        of the information provided. Users should seek their own legal or real estate advice where appropriate. While we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express
                        or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services , or related graphics contained on the website for any purpose. Any reliance
                        you place on such information is therefore strictly at your own risk.</p>
                    <p style="font-size: 11px;margin-bottom:7px"> In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with,
                        the use of this website .</p>
                    <p style="font-size: 11px;margin-bottom:7px">Through this website you are able to link to other websites which are not under the control of M/s Propira Global Private Limited, the owner of this website. We have no control over the nature, content and availability of those sites.
                        The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
                    <p style="font-size: 11px;margin-bottom:7px">Every effort is made to keep the website up and running smoothly. However, we take no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
                    </p>
                </div>
            </div>
            <!-- copyright-->
            <div class="col-xl-12 col-md-12 col-sm-12 col-lg-12 col-12">
                <div class="copyright">
                    <p> Copyright &copy;2021 All Rights Reserved
                    </p>
                </div>
            </div>
        </div>
    </div>


</div>



<!--<div class="container-fluid">
    <div class="container">
        <img src="assets/images/footer.png" class="img-fluid">
    </div>
</div>-->